import { useTheme } from 'styled-components'

import { LotResponse } from '@nx/api'
import { FireExpandableContent } from '@nx/fire/expandable-content'
import { extractDataFromHTML } from '@nx/helpers'
import { SmartlingAttributes } from '@nx/smartling'

import {
  DescriptionTitle,
  ExtendedDescription,
  LotDesc,
  LotDescriptionContainer,
  LotName,
} from './Description.styles'

export function Description({ lot }: DescriptionProps) {
  const { colours } = useTheme()

  const lotName = extractDataFromHTML(lot.sCatalogDesc, 'LotName')
  const lotDesc = extractDataFromHTML(lot.sCatalogDesc, 'LotDesc')

  return (
    <LotDescriptionContainer {...SmartlingAttributes.noTranslate}>
      <FireExpandableContent
        cutOffHeight={{ xs: 400, sm: 400, md: 400, lg: 500, xl: 500, xxl: 500 }}
        fadeOutColour={colours.grey['30']}
        key={lot.iSaleLotNo}
      >
        <>
          {lotName && (
            <LotName
              dangerouslySetInnerHTML={{
                __html: lotName,
              }}
            />
          )}
          {lotDesc && (
            <LotDesc
              dangerouslySetInnerHTML={{
                __html: lotDesc,
              }}
            />
          )}
          {lot.footnote_sExtraDesc && (
            <ExtendedDescription>
              <DescriptionTitle>Footnotes</DescriptionTitle>
              <p
                dangerouslySetInnerHTML={{
                  __html: lot.footnote_sExtraDesc,
                }}
              />
            </ExtendedDescription>
          )}

          {lot.notices && (
            <ExtendedDescription>
              <DescriptionTitle>Saleroom notices</DescriptionTitle>
              <p dangerouslySetInnerHTML={{ __html: lot.notices }} />
            </ExtendedDescription>
          )}
        </>
      </FireExpandableContent>
    </LotDescriptionContainer>
  )
}

export interface DescriptionProps {
  lot: LotResponse
}
